import { Container, Section } from '@components';
import useAuthStore from '@/stores/authStore';

const Profile = () => {
  const { user } = useAuthStore();

  return (
    <div className="bg-neutral-soft-gray min-h-screen">
      <Section>
        <Container>
          <div className="max-w-2xl mx-auto">
            <h1 className="text-h2 text-primary-navy mb-8">Profile</h1>
            
            <div className="bg-white rounded-2xl shadow-card p-8">
              <div className="flex items-center gap-6 mb-8">
                <div className="w-20 h-20 rounded-full bg-primary-navy flex items-center justify-center text-white font-semibold text-2xl">
                  {user?.displayName?.charAt(0).toUpperCase() || 'U'}
                </div>
                <div>
                  <h2 className="text-h4 text-neutral-charcoal">{user?.displayName || 'User'}</h2>
                  <p className="text-body text-neutral-medium-gray">{user?.email}</p>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-neutral-charcoal mb-2">Display Name</label>
                  <input
                    type="text"
                    defaultValue={user?.displayName || ''}
                    className="w-full px-4 py-2 border border-neutral-soft-gray rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-teal"
                    disabled
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-neutral-charcoal mb-2">Email</label>
                  <input
                    type="email"
                    defaultValue={user?.email || ''}
                    className="w-full px-4 py-2 border border-neutral-soft-gray rounded-lg bg-neutral-soft-gray"
                    disabled
                  />
                </div>
              </div>

              <p className="text-small text-neutral-medium-gray mt-6 text-center">
                Coming soon: Full profile editing functionality
              </p>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Profile;
